import { createState, useState } from '@hookstate/core';

interface CustomerListState {
  detailDrawerOpen: boolean;
  customerId: string;
}

const initialState: CustomerListState = {
  detailDrawerOpen: false,
  customerId: '',
};

const customerListState = createState(initialState);

export function useCustomerListState() {
  return useState(customerListState);
}
